import { render } from "./P034.vue?vue&type=template&id=41117350&scoped=true"
import script from "./P034.vue?vue&type=script&lang=js"
export * from "./P034.vue?vue&type=script&lang=js"

import "./P034.vue?vue&type=style&index=0&id=41117350&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41117350"]])

export default __exports__